import type { VehicleSchemeQuoteResult } from '../SchemeQuoteResult'
import { JsonObject, JsonProperty } from 'json2typescript'
import PaymentTypeEnumConverter from '@/converters/PaymentTypeEnumConverter'
import { PaymentTypeEnum } from '@/services/enums/DLDCommonValuesEnum'
import QuoteDetails from '../QuoteDetails'
import VehicleDriver from './VehicleDriver'
import VehicleProposer from './VehicleProposer'
import VehicleRiskVehicle from './VehicleRiskVehicle'

@JsonObject('VehicleQuoteDetails')
export default class VehicleQuoteDetails extends QuoteDetails<VehicleSchemeQuoteResult> {
  @JsonProperty('vehicleProposer', VehicleProposer)
  vehicleProposer: VehicleProposer = new VehicleProposer()

  @JsonProperty('vehicles', [VehicleRiskVehicle])
  vehicles: VehicleRiskVehicle[] = []

  @JsonProperty('vehicleDrivers', [VehicleDriver])
  vehicleDrivers: VehicleDriver[] = []
}

@JsonObject('VehicleRenewalQuoteDetails')
export class VehicleRenewalQuoteDetails extends VehicleQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('previousPolicyScheme', String)
  previousPolicyScheme = ''
}

@JsonObject('VehicleMTAQuoteDetails')
export class VehicleMTAQuoteDetails extends VehicleQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('hasUpgradableVAP', Boolean)
  hasUpgradableVAP = true

  @JsonProperty('hasClaims', Boolean)
  hasClaims = false

  @JsonProperty('message', String)
  message = ''
}
